import styled from "styled-components";
import { ReactComponent as Elipsis4 } from "../../../assets/img/icons/Elipsis4.svg";
import { ReactComponent as CheckCircle } from "../../../assets/img/icons/CheckCircle.svg";
import { ReactComponent as Cross } from "../../../assets/img/icons/cross.svg";
import { Popover } from "antd";

const PasswordValid = (props) => {
  const text = <span>Weak password</span>;
  const content = (
    <div>
      <ul>
        <li>
          {props.uppercase === "true" ? <CheckCircle /> : <Cross />}
          <span>
            Contain at least one <strong>UPPERCASE letter</strong>
          </span>
        </li>
        <li>
          {props.number === "true" ? <CheckCircle /> : <Cross />}
          <span>
            Contain at least one <strong>Number (0-9)</strong>
          </span>
        </li>
        <li>
          {props.special === "true" ? <CheckCircle /> : <Cross />}
          <span>
            Contain at least one <strong>special character (@, #, $, %)</strong>
          </span>
        </li>
        <li>
          {props.long === "true" ? <CheckCircle /> : <Cross />}
          <span>
            Be at least <strong>8 characters long</strong>
          </span>
        </li>
      </ul>
    </div>
  );
  return (
    <WrapperStyle>
      <Popover
        placement="rightTop"
        title={text}
        content={content}
        trigger="click"
        overlayClassName="password-hint"
      >
        <span>
          Strength <Elipsis4 />
        </span>
      </Popover>
    </WrapperStyle>
  );
};
export default PasswordValid;

const WrapperStyle = styled.div`
  position: absolute;
  right: 50px;
  top: 25px;
  span {
    color: rgb(94, 112, 121);
    font-size: 10px;
    font-family: "robotoregular";
    cursor: pointer;
    svg {
      margin-left: 2px;
    }
  }
`;
